<template>
  <div>
    <v-card elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row dense class="mb-1 align-center">
        <v-col cols="12" sm="6" md="6" lg="4">
          <v-text-field class="search-field" v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify"
            label="Search..." single-line solo hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-select solo v-model="account_type" :items="formattedAccountTypes" item-text="text" item-value="value"
            append-icon="mdi-chevron-down" label="Account Type" class="custom-select"
            @change="handleAccountTypeChange"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-select solo v-model="country" :items="[{ id: null, name: 'All' }, ...countries]" item-text="name"
            item-value="id" append-icon="mdi-chevron-down" label="Country" class="custom-select"
            @change="handleCountryChange"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="2">
          <ul class="ib-list">
            <li>
              <span>Total Parent IB</span>
              <span>{{ masterIbPagination?.total }}</span>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
        <v-data-table :headers="headers" :items="allMasterIBDataTable"
          :server-items-length="masterIbPagination?.total || 10" :options.sync="options" :loading="isLoading"
          :items-per-page="options.itemsPerPage" :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': 'Rows per page:'
          }" @update:options="handleOptionsChange" disable-sort>
          <template v-slot:loading>
            <div class="d-flex align-center justify-center pa-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <span class="ml-2">Loading data...</span>
            </div>
          </template>
          <template v-slot:no-data>
            <div class="d-flex align-center justify-center pa-4">
              <v-icon color="secondary">mdi-information</v-icon>
              <span class="ml-2">No data found</span>
            </div>
          </template>
          <template v-slot:no-results>
            <div class="d-flex align-center justify-center pa-4">
              <v-icon color="secondary">mdi-magnify</v-icon>
              <span class="ml-2">No matching data found</span>
            </div>
          </template>
          <template v-slot:item.fullname="{ item }">
            <router-link class="text-capitalize text--ash" :to="`/partner-list-details?id=${item.id}`">
              {{ item.fullname }}
            </router-link>
          </template>
          <template v-slot:item.sl="{ index, item }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.countries.name="{ item }">
            {{ item.countries.name }}
          </template>
          <template v-slot:item.tradingAccountTypes="{ item }">
            {{ item.tradingAccountTypes.length }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex align-center justify-center">
              <v-dialog transition="scale-transition" origin="center center" max-width="500"
                v-model="editDialog[item?.id]" content-class="commission-settings">
                <template v-slot:activator="{ on, attrs }">
                  <div class="links text-decoration-none mr-3">
                    <div v-bind="attrs" v-on="on" @click="openEditDialog(item)">
                      <v-icon color="#039de9" small>mdi-pencil-outline</v-icon>
                    </div>
                  </div>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="mb-5 pl-3 pt-0">Edit - Assigned Acc. Type</v-card-title>
                  <v-card-subtitle class="text--ash mb-3 pl-3">
                    {{ selectedIB.fullname }} - {{ selectedIB.id }} - {{ selectedIB.countries?.name }}
                    <br />{{ selectedIB.email }} - Balance: ${{ selectedIB.business_amount }}
                  </v-card-subtitle>
                  <v-card class="assign-account-type" elevation="0"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <v-card class="mb-2" :color="$vuetify.theme.dark ? 'transparent' : '#f2f7fb'" flat tile>
                          <ul class="chips small-chips">
                            <li v-for="accType in allAccountTypesDataTable" :key="accType.id"
                              :class="{ 'border-color': isAccountTypeSelected(accType.id) }"
                              @click="toggleAccountType(accType.id)">
                              <input v-show="isAccountTypeSelected(accType.id)"
                                class="custom-checkbox custom-checkbox-small" type="checkbox"
                                :checked="isAccountTypeSelected(accType.id)" />
                              {{ accType.account_type_display }} ({{ accType.LiveDemo }})
                            </li>
                          </ul>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="6">
                        <v-btn tile block @click="handleSave" elevation="0" class="text-capitalize btn-account"
                          color="greenMain">
                          Save
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn tile block color="#FF567F" @click="closeEditDialog(item)" elevation="0"
                          class="text-capitalize btn-account">
                          Close
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog transition="scale-transition" origin="center center" max-width="500"
                v-model="viewDialog[item?.id]" content-class="commission-settings">
                <template v-slot:activator="{ on, attrs }">
                  <div class="links text-decoration-none">
                    <div v-bind="attrs" v-on="on" @click="openViewDialog(item)">
                      <v-icon color="#039de9" small>mdi-eye-outline</v-icon>
                    </div>
                  </div>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="mb-5 pl-3 pt-0">View - Assigned Acc. Type</v-card-title>
                  <v-card-subtitle class="text--ash mb-3 pl-3">
                    {{ selectedIB.fullname }} - {{ selectedIB.id }} - {{ selectedIB.countries?.name }}
                    <br />{{ selectedIB.email }} - Balance: ${{ selectedIB.business_amount }}
                  </v-card-subtitle>
                  <v-card class="assign-account-type" elevation="0"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <v-card class="mb-2" :color="$vuetify.theme.dark ? 'transparent' : '#f2f7fb'" flat tile>
                          <ul class="chips small-chips">
                            <li v-for="accType in selectedIB.tradingAccountTypes" :key="accType.id">
                              {{ accType.account_type_display }}
                            </li>
                          </ul>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="6">
                        <v-btn tile block color="#FF567F" @click="closedViewDialog(item)" elevation="0"
                          class="text-capitalize btn-account">
                          Close
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </template>
        </v-data-table>
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import toast from "@/services/Notification";
import { ASSIGNACCTYPE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  name: 'AssignAccountTypeDataTable',
  props: {
    allAccountTypesDataTable: {
      type: Array,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      account_type: "",
      country: "",
      search: "",
      searchTimeout: null,
      isLoading: false,
      editDialog: {},
      viewDialog: {},
      selectedIB: {},
      selectedAccountTypes: [],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "SR No.", align: "start", value: "sl" },
        { text: "IB Code", value: "id" },
        { text: "IB Name", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Country", value: "countries.name" },
        { text: "Total Child", value: "total_child" },
        { text: "Business Amount", value: "business_amount" },
        { text: "Commission", value: "ib_commission" },
        { text: "Total Acc. Type", value: "tradingAccountTypes" },
      ]
    };
  },
  computed: {
    ...mapState("assignacctype", [
      'allMasterIBDataTable',
      'masterIbPagination'
    ]),
    formattedAccountTypes() {
      const accountTypes = this.allAccountTypesDataTable.map(type => {
        return {
          text: `${type.account_type_display} (${type.LiveDemo})`,
          value: type.id
        };
      });

      // Add the "All" option at the beginning of the array
      accountTypes.unshift({
        text: 'All',
        value: null
      });

      return accountTypes;
    }

  },
  methods: {
    formatMySQLDate,
    ...mapActions("assignacctype", [
      ASSIGNACCTYPE__ACTIONS.ASSIGNSINGLEIB,
      ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE
    ]),
    closeEditDialog(item) {
      this.$set(this.editDialog, item?.id, false);
    },
    closedViewDialog(item) {
      this.$set(this.viewDialog, item?.id, false);
    },
    openEditDialog(item) {
      this.selectedIB = { ...item };
      this.selectedAccountTypes = item.tradingAccountTypes.map(type => type.id);
      this.$set(this.editDialog, item?.id, true);
    },
    openViewDialog(item) {
      this.selectedIB = { ...item };
      this.$set(this.viewDialog, item?.id, true);
    },
    isAccountTypeSelected(typeId) {
      return this.selectedAccountTypes.includes(typeId);
    },
    toggleAccountType(typeId) {
      const index = this.selectedAccountTypes.indexOf(typeId);
      if (index === -1) {
        this.selectedAccountTypes.push(typeId);
      } else {
        this.selectedAccountTypes.splice(index, 1);
      }
    },
    handleSave() {
      this[ASSIGNACCTYPE__ACTIONS.ASSIGNSINGLEIB]({
        partner_id: this.selectedIB.id,
        account_types: this.selectedAccountTypes
      });
      this.editDialog = false;
    },
    async fetchData() {
      try {
        this.isLoading = true
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search,
          account_type: this.account_type,
          country: this.country,
        };

        await this[ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE](params);
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },


    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleAccountTypeChange() {
      this.fetchData();
    },

    handleOptionsChange() {
      this.fetchData();
    },

    handleCountryChange() {
      this.fetchData();
    },
  },
  async created() {
   // { text: "Action", value: "actions", sortable: false }
    await this.fetchData();
    if (this.$canRoute('assign-account-type') === 1) {
      this.headers.push({ text: "Action", value: "actions" });
    }
  },
};
</script>